/* eslint-disable
    eqeqeq,
    @trello/disallow-filenames,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { CustomEvent } from './custom-event';

export const triggerList = function (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  targets: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventName: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any,
) {
  // @ts-expect-error TS(2351): This expression is not constructable.
  const event = new CustomEvent(eventName, {
    bubbles: false,
    cancelable: false,
    detail: options.detail != null ? options.detail : undefined,
  });

  let stopped = false;

  event.stopPropagation = function () {
    stopped = true;
    // @ts-expect-error TS(2345): Argument of type 'IArguments' is not assignable to... Remove this comment to see the full error message
    return CustomEvent.prototype.stopPropagation.apply(this, arguments);
  };

  for (const target of Array.from(targets)) {
    if (!stopped) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      target.dispatchEvent(event);
    }
  }
};
